const { VITE_BRAND } = import.meta.env;
export default {
  "resources": {
    "-xmlns:tools": "http://schemas.android.com/tools",
    "-xmlns:xliff": "urn:oasis:names:tc:xliff:document:1.2",
    "-tools:ignore": "MissingTranslation",
    "string": [
      {
        "-name": "nova_community_login_or_register",
        "#text": "Log in or register"
      },
      {
        "-name": "nova_community_login_continue",
        "#text": "Please log in to continue"
      },
      {
        "-name": "nova_community_time_now",
        "#text": "Just now"
      },
      {
        "-name": "nova_community_image_save_success",
        "#text": "Image downloaded"
      },
      {
        "-name": "nova_community_image_save_failed",
        "#text": "Downloading failed"
      },
      {
        "-name": "nova_community_image_show_larger",
        "#text": "Full image"
      },
      {
        "-name": "nova_community_no_network_connection",
        "#text": "Network error"
      },
      {
        "-name": "nova_community_load_state_loading",
        "#text": "Loading…"
      },
      {
        "-name": "nova_community_label_mention_recent",
        "#text": "Recent"
      },
      {
        "-name": "nova_community_yes",
        "#text": "Yes"
      },
      {
        "-name": "nova_community_message_server_error",
        "#text": "An error occurred. Please try again later."
      },
      {
        "-name": "nova_community_menu_unmarked",
        "#text": "Unfavorite"
      },
      {
        "-name": "nova_community_profile_tab_threads",
        "#text": "Threads"
      },
      {
        "-name": "nova_community_profile_tab_posts",
        "#text": "Comments"
      },
      {
        "-name": "nova_community_profile_tab_saved",
        "#text": "Favorites"
      },
      {
        "-name": "nova_community_profile_tab_likes",
        "#text": "Likes"
      },
      {
        "-name": "nova_community_label_avatar",
        "#text": "Avatar"
      },
      {
        "-name": "nova_community_label_following",
        "#text": "Following"
      },
      {
        "-name": "nova_community_label_followers",
        "#text": "Followers"
      },
      {
        "-name": "nova_community_confirm_logout",
        "#text": "Log out?"
      },
      {
        "-name": "nova_community_menu_edit_profile",
        "#text": "Edit"
      },
      {
        "-name": "nova_community_menu_reviewing_list",
        "#text": "Unposted threads"
      },
      {
        "-name": "nova_community_menu_about",
        "#text": "About us"
      },
      {
        "-name": "nova_community_menu_user_id",
        "#text": "User ID"
      },
      {
        "-name": "nova_community_menu_privacy",
        "#text": "Privacy"
      },
      {
        "-name": "nova_community_menu_block",
        "#text": "Block"
      },
      {
        "-name": "nova_community_menu_hide_content",
        "#text": "Hide"
      },
      {
        "-name": "nova_community_menu_block_list",
        "#text": "Block list"
      },
      {
        "-name": "nova_community_menu_use_system_language",
        "#text": "Follow system language"
      },
      {
        "-name": "nova_community_menu_upgrade",
        "#text": "Check for updates"
      },
      {
        "-name": "nova_community_menu_my_feedback",
        "#text": "My Feedback"
      },
      {
        "-name": "nova_community_menu_logout",
        "#text": "Log out"
      },
      {
        "-name": "nova_community_menu_settings",
        "#text": "Settings"
      },
      {
        "-name": "nova_community_posts_label",
        "#text": "Threads"
      },
      {
        "-name": "nova_community_button_follow",
        "#text": "Follow"
      },
      {
        "-name": "nova_community_button_following",
        "#text": "Following"
      },
      {
        "-name": "nova_community_dialog_title_red_coins_agreement",
        "#text": "Agreement"
      },
      {
        "-name": "nova_community_dialog_content_red_coins",
        "#cdata-section": "You need to agree to <terms>RedCoins Terms of Use</terms> to visit the Point Center",
        "#text": "."
      },
      {
        "-name": "nova_community_dialog_red_coins_button_disagree",
        "#text": "Disagree"
      },
      {
        "-name": "nova_community_dialog_red_coins_button_agree",
        "#text": "Agree"
      },
      {
        "-name": "nova_community_title_point_center",
        "#text": "Point Center"
      },
      {
        "-name": "nova_community_subtitle_point_center",
        "#text": "Get RedCoins and win prizes"
      },
      {
        "-name": "nova_community_installed_latest_version",
        "#text": "You have installed the latest version"
      },
      {
        "-name": "nova_community_dialog_title_new_version",
        "#text": "A new version is available (%1$s)"
      },
      {
        "-name": "nova_community_button_update",
        "#text": "Update"
      },
      {
        "-name": "nova_community_button_later",
        "#text": "Later"
      },
      {
        "-name": "nova_community_dialog_title_downloading",
        "#text": "Downloading..."
      },
      {
        "-name": "nova_community_dialog_un_follow_ok",
        "#text": "Unfollow"
      },
      {
        "-name": "nova_community_dialog_un_follow_cancel",
        "#text": "Cancel"
      },
      {
        "-name": "nova_community_dialog_un_follow_tips",
        "#text": "Unfollow this user?"
      },
      {
        "-name": "nova_community_verification_failed",
        "#text": "File verification failed. Please try again."
      },
      {
        "-name": "nova_community_about_terms",
        "#text": "Terms of Use"
      },
      {
        "-name": "nova_community_about_open_source",
        "#text": "Open Source Licenses"
      },
      {
        "-name": "nova_community_article_reviewing_list",
        "#text": "Unposted threads"
      },
      {
        "-name": "nova_community_about_personal_information_list",
        "#text": "Personal Information We Collect"
      },
      {
        "-name": "nova_community_about_third_party_information_list",
        "#text": "Personal Information We Share with Third Parties"
      },
      {
        "-name": "nova_community_about_policy",
        "#text": "Privacy Notice"
      },
      {
        "-name": "nova_community_title_medals_entrance",
        "#text": "Medals"
      },
      {
        "-name": "nova_community_google_play_not_installed",
        "#text": "You haven't installed Google Play Store on your phone"
      },
      {
        "-name": "nova_community_label_red_coins_amount",
        "#text": "RedCoins"
      },
      {
        "-name": "nova_community_title_point_store",
        "#text": "Point Store"
      },
      {
        "-name": "nova_community_subtitle_point_store",
        "#text": "Complete tasks to save money"
      },
      {
        "-name": "nova_community_card_title_point_store",
        "#text": "\"Redeem RedCoins\""
      },
      {
        "-name": "nova_community_card_subtitle_point_store",
        "#text": "\"More than you expect\""
      },
      {
        "-name": "nova_community_title_red_coins",
        "#text": "Earn RedCoins"
      },
      {
        "-name": "nova_community_subtitle_red_coins",
        "#text": "Complete tasks to save money"
      },
      {
        "-name": "nova_community_task_button_un_available",
        "#text": "\"Unavailable\""
      },
      {
        "-name": "nova_community_task_button_doing",
        "#text": "\"Doing\""
      },
      {
        "-name": "nova_community_task_button_go",
        "#text": "Go"
      },
      {
        "-name": "nova_community_task_button_done",
        "#text": "\"Done\""
      },
      {
        "-name": "nova_community_rate_of_progress",
        "#text": "\"%1$d/%2$d\""
      },
      {
        "-name": "nova_community_label_point_history",
        "#text": "Point history"
      },
      {
        "-name": "nova_community_menu_point_history",
        "#text": "History"
      },
      {
        "-name": "nova_community_menu_terms",
        "#text": "Terms & Conditions"
      },
      {
        "-name": "nova_community_title_medal_list",
        "#text": "Medals"
      },
      {
        "-name": "nova_community_medal_more",
        "#text": "More"
      },
      {
        "-name": "nova_community_menu_confirm",
        "#text": "OK"
      },
      {
        "-name": "nova_community_medal_type_upgradable",
        "#text": "Upgradable medals"
      },
      {
        "-name": "nova_community_medal_type_achievement",
        "#text": "Achievement medals"
      },
      {
        "-name": "nova_community_medal_type_limited",
        "#text": "Exclusive medals"
      },
      {
        "-name": "nova_community_medal_type_series",
        "#text": "Event medals"
      },
      {
        "-name": "nova_community_album_all",
        "#text": "All"
      },
      {
        "-name": "nova_community_album_root",
        "#text": "System"
      },
      {
        "-name": "nova_community_button_done_empty",
        "#text": "Add"
      },
      {
        "-name": "nova_community_button_done_selected",
        "#text": "Add (%1$d/%2$d)"
      },
      {
        "-name": "nova_community_button_switch_album",
        "#text": "Switch album"
      },
      {
        "-name": "nova_community_check_select",
        "#text": "Select"
      },
      {
        "-name": "nova_community_error_need_permission",
        "#text": "\"No permission to access Storage\""
      },
      {
        "-name": "nova_community_permission_read_rationale",
        "#text": "Permission required: access images and videos from Storage"
      },
      {
        "-name": "nova_community_button_launch_permission_settings",
        "#text": "Go to Settings"
      },
      {
        "-name": "nova_community_media_selected_limit",
        "#text": "The number of items selected has exceeded the limit"
      },
      {
        "-name": "nova_community_open_with_browser",
        "#text": "Open in browser"
      },
      {
        "-name": "nova_community_loading",
        "#text": "Loading…"
      },
      {
        "-name": "nova_community_login_failed",
        "#text": "Login failed"
      },
      {
        "-name": "nova_community_blank_no_search_result",
        "#text": "No result"
      },
      {
        "-name": "nova_community_blank_error_message",
        "#text": "An error occurred. Please try again later."
      },
      {
        "-name": "nova_community_blank_button_retry",
        "#text": "Retry"
      },
      {
        "-name": "nova_community_server_error",
        "#text": "An error occurred. Please try again later."
      },
      {
        "-name": "nova_community_delete",
        "#text": "Delete"
      },
      {
        "-name": "nova_community_article_deleted",
        "#text": "Deleted"
      },
      {
        "-name": "nova_community_article_pinned",
        "#text": "Post stickied"
      },
      {
        "-name": "nova_community_review_passed",
        "#text": "Review passed"
      },
      {
        "-name": "nova_community_submitted_successfully",
        "#text": "Submitted"
      },
      {
        "-name": "all_loaded",
        "#text": "No more content"
      },
      {
        "-name": "loading",
        "#text": "Loading"
      },
      {
        "-name": "load_failed",
        "#text": "Loading failed"
      },
      {
        "-name": "no_network",
        "#text": "No network connection"
      },
      {
        "-name": "try_again",
        "#text": "Please try again."
      },
      {
        "-name": "no_content",
        "#text": "No content"
      },
      {
        "-name": "un_login",
        "#text": "Log in to view the circles you have joined."
      },
      {
        "-name": "no_join_circle",
        "#text": "You haven't joined any circle yet."
      },
      {
        "-name": "nova_more_circles",
        "#text": "Explore more circles"
      },
      {
        "-name": "nova_community_push_switch",
        "#text": "Push notifications"
      },
      {
        "-name": "nova_community_push_switch_system",
        "#text": "Notifications disabled"
      },
      {
        "-name": "nova_community_push_switch_system_summary",
        "#text": "You have disabled OnePlus Community's push notifications in your phone settings. Tap here to go to settings."
      },
      {
        "-name": "nova_community_push_switch_tag",
        "#text": "New tags"
      },
      {
        "-name": "nova_community_push_switch_comment",
        "#text": "New comments"
      },
      {
        "-name": "nova_community_push_switch_reply",
        "#text": "New replies"
      },
      {
        "-name": "nova_community_push_switch_follower",
        "#text": "New followers"
      },
      {
        "-name": "nova_community_push_switch_like_thread",
        "#text": "New likes"
      },
      {
        "-name": "nova_community_push_switch_new_messages",
        "#text": "New messages"
      },
      {
        "-name": "nova_community_add_saved_success",
        "#text": "Added to Favorites"
      },
      {
        "-name": "nova_community_article_input_comment_hint",
        "#text": "Add a comment"
      },
      {
        "-name": "nova_community_article_reply_comment_hint",
        "#text": "Reply to %1$s:"
      },
      {
        "-name": "nova_community_send_a_comment_description",
        "#text": "Send"
      },
      {
        "-name": "nova_community_sort_by_default",
        "#text": "Latest"
      },
      {
        "-name": "nova_community_sort_by_time",
        "#text": "Earliest"
      },
      {
        "-name": "nova_community_sort_by_heat",
        "#text": "Most liked"
      },
      {
        "-name": "nova_community_menu_bookmark",
        "#text": "Favorite"
      },
      {
        "-name": "nova_community_menu_report",
        "#text": "Report"
      },
      {
        "-name": "nova_community_menu_remove",
        "#text": "Delete"
      },
      {
        "-name": "nova_community_menu_sticky",
        "#text": "Sticky"
      },
      {
        "-name": "nova_community_menu_turn_off_sticky",
        "#text": "Unsticky"
      },
      {
        "-name": "nova_community_menu_edit",
        "#text": "Edit"
      },
      {
        "-name": "nova_community_menu_share",
        "#text": "Share"
      },
      {
        "-name": "nova_community_menu_copy_text",
        "#text": "Copy text"
      },
      {
        "-name": "nova_community_menu_copy_link",
        "#text": "Copy link"
      },
      {
        "-name": "nova_community_menu_quote",
        "#text": "Quote"
      },
      {
        "-name": "nova_community_quote_image",
        "#text": "[Picture]"
      },
      {
        "-name": "nova_community_quote_empty_content",
        "#text": "Quotes must contain content"
      },
      {
        "-name": "nova_community_discover_search_query_hint",
        "#text": "Search"
      },
      {
        "-name": "nova_community_label_all_circles",
        "#text": "All Circles"
      },
      {
        "-name": "nova_community_label_new_circle",
        "#text": "Create a circle"
      },
      {
        "-name": "nova_community_label_edit_circle_description",
        "#text": "Edit"
      },
      {
        "-name": "nova_community_label_manage_members",
        "#text": "Manage members"
      },
      {
        "-name": "nova_community_label_mention_members",
        "#text": "\\@"
      },
      {
        "-name": "nova_community_label_request",
        "#text": "Circle request"
      },
      {
        "-name": "nova_community_button_text_join",
        "#text": "Join"
      },
      {
        "-name": "nova_community_dialog_title_remove_content",
        "#text": "Delete this content?"
      },
      {
        "-name": "nova_community_add_link_title_hint",
        "#text": "Text (optional)"
      },
      {
        "-name": "nova_community_add_link_url_hint",
        "#text": "Link"
      },
      {
        "-name": "nova_community_add_link_illegal_url",
        "#text": "Invalid link. Please add a link starting with http:// or https://"
      },
      {
        "-name": "nova_community_add_link_page_title",
        "#text": "Add link"
      },
      {
        "-name": "nova_community_my_circles_title",
        "#text": "My Circles"
      },
      {
        "-name": "nova_community_quite_circle_message",
        "#text": "Leave this circle?"
      },
      {
        "-name": "nova_community_circle_owner",
        "#text": "Owned by ",
        "xliff:g": {
          "-example": "Pete",
          "-id": "owner",
          "#text": "%1$s"
        }
      },
      {
        "-name": "nova_community_title_name_founder",
        "#text": "Owner"
      },
      {
        "-name": "nova_community_title_name_assistant",
        "#text": "Circle assistant"
      },
      {
        "-name": "nova_community_title_name_civilian",
        "#text": "Member"
      },
      {
        "-name": "nova_community_action_set_assistant",
        "#text": "Set as circle assistant"
      },
      {
        "-name": "nova_community_action_set_civilian",
        "#text": "Remove as circle assistant"
      },
      {
        "-name": "nova_community_action_remove_from_circle",
        "#text": "Remove"
      },
      {
        "-name": "nova_community_circle_name_duplicate",
        "#text": "This circle name has already been taken"
      },
      {
        "-name": "nova_community_circle_member_search_hint",
        "#text": "Search for a user"
      },
      {
        "-name": "nova_community_mention_member_search_hint",
        "#text": "Search for a user"
      },
      {
        "-name": "nova_community_circle_apply_dialog_title",
        "#text": "Reason for application"
      },
      {
        "-name": "nova_community_circle_apply_dialog_edit_hint",
        "#text": "Tell the circle owner why you want to join this circle"
      },
      {
        "-name": "nova_community_circle_join_btn_pending",
        "#text": "Pending"
      },
      {
        "-name": "nova_community_circle_wait_for_review",
        "#text": "Submitted successfully. Please wait for review."
      },
      {
        "-name": "nova_community_owner_flag",
        "#text": "Owner"
      },
      {
        "-name": "nova_community_create_circle_add_cover",
        "#text": "Add a circle cover"
      },
      {
        "-name": "nova_community_label_circle_name",
        "#text": "Circle name"
      },
      {
        "-name": "nova_community_circle_name_hint",
        "#text": "Name your circle"
      },
      {
        "-name": "nova_community_label_circle_introduction",
        "#text": "Circle introduction"
      },
      {
        "-name": "nova_community_circle_introduction_hint",
        "#text": "Introduce your circle"
      },
      {
        "-name": "nova_community_label_application_reason",
        "#text": "Reason for application"
      },
      {
        "-name": "nova_community_application_reason_hint",
        "#text": "Tell us why you want to create this circle"
      },
      {
        "-name": "nova_community_label_join_permission",
        "#text": "Permission required?"
      },
      {
        "-name": "nova_community_circle_join_with_permission",
        "#text": "Members need permission to join"
      },
      {
        "-name": "nova_community_circle_join_without_permission",
        "#text": "Members don't need permission to join"
      },
      {
        "-name": "nova_community_label_circle_administrator",
        "#text": "Circle administrator"
      },
      {
        "-name": "nova_community_load_state_retry",
        "#text": "Loading failed, please try again"
      },
      {
        "-name": "nova_community_load_state_page_end",
        "#text": "The end"
      },
      {
        "-name": "nova_community_text_empty_toast",
        "#text": "This field cannot be left blank"
      },
      {
        "-name": "nova_community_text_exceeded_toast",
        "#text": "This comment exceeds the word limit"
      },
      {
        "-name": "nova_community_report_title",
        "#text": "Report"
      },
      {
        "-name": "nova_community_action_remove",
        "#text": "Delete"
      },
      {
        "-name": "nova_community_action_report",
        "#text": "Report"
      },
      {
        "-name": "nova_community_action_edit",
        "#text": "Edit"
      },
      {
        "-name": "nova_community_action_report_reason_hint",
        "#text": "Please tell us why you want to report (optional)"
      },
      {
        "-name": "nova_community_action_report_submit",
        "#text": "Submit"
      },
      {
        "-name": "nova_community_comment_detail_see_article",
        "#text": "See parent thread"
      },
      {
        "-name": "nova_community_comment_deleted",
        "#text": "This comment has been deleted"
      },
      {
        "-name": "nova_community_all_comments_label",
        "#text": "All comments (%1$d)"
      },
      {
        "-name": "nova_community_comment_successfully",
        "#text": "Posted"
      },
      {
        "-name": "nova_community_edit_exit_tips",
        "#text": "Discard your edit?"
      },
      {
        "-name": "nova_community_edit_exit_cancel",
        "#text": "Cancel"
      },
      {
        "-name": "nova_community_edit_exit_yes",
        "#text": "Discard"
      },
      {
        "-name": "nova_community_request_processed",
        "#text": "This request has been processed"
      },
      {
        "-name": "nova_community_view_full_comment",
        "#text": "View full comment"
      },
      {
        "-name": "error_network_anomaly",
        "#text": "An error occurred. Please try again later."
      },
      {
        "-name": "error_network_connection_failed",
        "#text": "An error occurred. Please try again later."
      },
      {
        "-name": "error_network_Request_timed_out",
        "#text": "An error occurred. Please try again later."
      },
      {
        "-name": "error_data_parsing_error",
        "#text": "An error occurred. Please try again later."
      },
      {
        "-name": "nova_community_label_publisher_article",
        "#text": "Article"
      },
      {
        "-name": "nova_community_label_publisher_moment",
        "#text": "Moment"
      },
      {
        "-name": "nova_community_label_publisher_poll",
        "#text": "Poll"
      },
      {
        "-name": "nova_community_label_publisher_feed_back",
        "#text": "Feedback"
      },
      {
        "-name": "nova_community_label_publisher_edit_article",
        "#text": "Edit"
      },
      {
        "-name": "nova_community_menu_publisher_article_post",
        "#text": "Post"
      },
      {
        "-name": "nova_community_menu_publisher_article_preview",
        "#text": "Preview"
      },
      {
        "-name": "nova_community_publisher_article_title_hint",
        "#text": "Title"
      },
      {
        "-name": "nova_community_publisher_article_content_hint",
        "#text": "Let's build the OnePlus Community together!"
      },
      {
        "-name": "publisher_publish_loading_text",
        "#text": "Posting"
      },
      {
        "-name": "publisher_publish_exit_tips",
        "#text": "Save as draft?"
      },
      {
        "-name": "publisher_publish_exit_cancel",
        "#text": "Discard"
      },
      {
        "-name": "publisher_publish_exit_ok",
        "#text": "Save"
      },
      {
        "-name": "publisher_publish_post_auditing_tips",
        "#text": "Your post has been submitted. Please wait for the administrator to review."
      },
      {
        "-name": "publisher_publish_post_audit_fail_tips",
        "#text": "This content cannot be posted. This is likely because the content has triggered our spam filters or contains inappropriate elements."
      },
      {
        "-name": "publisher_publish_image_not_upload_tips",
        "#text": "The pictures are uploading. Please try again later."
      },
      {
        "-name": "publisher_publish_video_not_upload_tips",
        "#text": "The video is uploading. Please try again later."
      },
      {
        "-name": "publisher_publish_get_circle_list_fail_tips",
        "#text": "An error occurred. Please try again later."
      },
      {
        "-name": "publisher_publish_input_title_tips",
        "#text": "Please enter a title"
      },
      {
        "-name": "choose_circle_title_hint",
        "#text": "Choose a circle you have joined"
      },
      {
        "-name": "dialog_choose_circle_title",
        "#text": "Choose a circle"
      },
      {
        "-name": "nova_community_publisher_image_duplicate",
        "#text": "This picture has already been added"
      },
      {
        "-name": "nova_community_publisher_video_duplicate",
        "#text": "This video has already been added"
      },
      {
        "-name": "nova_community_publisher_video_youtube_duplicate",
        "#text": "This YouTube video has already been added"
      },
      {
        "-name": "nova_community_publisher_content_exceeded",
        "#text": "The content has exceeded the word limit"
      },
      {
        "-name": "nova_community_publisher_content_empty",
        "#text": "Write something before you post"
      },
      {
        "-name": "nova_community_publisher_select_circle",
        "#text": "Choose a circle"
      },
      {
        "-name": "nova_community_publisher_pictures_uploading",
        "#text": "The pictures are uploading. Please try again later."
      },
      {
        "-name": "nova_community_publisher_publish_success",
        "#text": "Posted"
      },
      {
        "-name": "nova_community_publisher_publish_failed",
        "#text": "Posting failed"
      },
      {
        "-name": "nova_community_publisher_publish_no_joined_hints",
        "#text": "You haven't joined this circle yet"
      },
      {
        "-name": "nova_community_publisher_publish_no_post_hints",
        "#text": "Only OnePlus staffs can create threads in this circle"
      },
      {
        "-name": "nova_community_publisher_can_not_change_circle",
        "#text": "You're not allowed to change the circle"
      },
      {
        "-name": "publisher_embed_video_dialog_title",
        "#text": "YouTube video link"
      },
      {
        "-name": "publisher_embed_video_dialog_ok",
        "#text": "OK"
      },
      {
        "-name": "publisher_embed_video_url_tips",
        "#text": "Please add YouTube video link"
      },
      {
        "-name": "home_my_circle_articles_counts_text",
        "#text": "Updates"
      },
      {
        "-name": "text_view_all_my_joined_circle",
        "#text": "View all"
      },
      {
        "-name": "home_my_circle_owner_text",
        "#text": "Owner"
      },
      {
        "-name": "nova_community_title_check_in",
        "#text": "\"Check-in\""
      },
      {
        "-name": "nova_community_title_search",
        "#text": "\"Search\""
      },
      {
        "-name": "nova_community_message_title_message",
        "#text": "Messages"
      },
      {
        "-name": "nova_community_message_title_notifications",
        "#text": "Notifications"
      },
      {
        "-name": "nova_community_message_title_likes",
        "#text": "Likes"
      },
      {
        "-name": "nova_community_message_title_activities",
        "#text": "Interactions"
      },
      {
        "-name": "nova_community_message_title_new_followers",
        "#text": "Followers"
      },
      {
        "-name": "nova_community_message_thread_deleted",
        "#text": "This thread has been deleted"
      },
      {
        "-name": "nova_community_message_comment_deleted",
        "#text": "This content has been deleted"
      },
      {
        "-name": "nova_community_message_picture_comment",
        "#text": "Picture comment"
      },
      {
        "-name": "nova_community_message_picture_thread",
        "#text": "No text content"
      },
      {
        "-name": "dialog_send",
        "#text": "Submit"
      },
      {
        "-name": "nova_title_edit",
        "#text": "Edit"
      },
      {
        "-name": "nova_title_about",
        "#text": "About us"
      },
      {
        "-name": "nova_title_setting",
        "#text": "Settings"
      },
      {
        "-name": "nova_title_notification_setting",
        "#text": "Push notification"
      },
      {
        "-name": "nova_toast_update_header",
        "#text": "Avatar updated"
      },
      {
        "-name": "nova_toast_update_nick",
        "#text": "Username updated"
      },
      {
        "-name": "nova_toast_update_sign",
        "#text": "Bio updated"
      },
      {
        "-name": "nova_dialog_edit_nick",
        "#text": "Username"
      },
      {
        "-name": "nova_dialog_edit_sign",
        "#text": "Bio"
      },
      {
        "-name": "community_login_session_expired",
        "#text": "Your session has expired. Please log in again."
      },
      {
        "-name": "nova_login_to_comment",
        "#text": "Please log in to comment"
      },
      {
        "-name": "nova_can_not_comment",
        "#text": "This thread is not open for comments"
      },
      {
        "-name": "nova_tab_home_explore",
        "#text": "Explore"
      },
      {
        "-name": "nova_tab_home_following",
        "#text": "My Following"
      },
      {
        "-name": "nova_community_text_no_following",
        "#text": "You haven't followed anyone yet."
      },
      {
        "-name": "nova_community_text_no_event",
        "#text": "No content"
      },
      {
        "-name": "nova_community_button_go_to_unread",
        "#text": "Go to the oldest unread thread"
      },
      {
        "-name": "nova_community_sort_by_recommend",
        "#text": "Recommended"
      },
      {
        "-name": "nova_community_sort_by_newly_post",
        "#text": "Newest posts"
      },
      {
        "-name": "nova_community_sort_by_newly_activity",
        "#text": "Newest replies"
      },
      {
        "-name": "decline",
        "#text": "Reject"
      },
      {
        "-name": "accept",
        "#text": "Accept"
      },
      {
        "-name": "edit_circle",
        "#text": "Edit"
      },
      {
        "-name": "exit_circle",
        "#text": "Leave"
      },
      {
        "-name": "manage_circle",
        "#text": "Manage members"
      },
      {
        "-name": "main_bottom_nav_menu_home",
        "#text": "Home"
      },
      {
        "-name": "main_bottom_nav_menu_discover",
        "#text": "Circles"
      },
      {
        "-name": "main_bottom_nav_menu_social",
        "#text": "Social"
      },
      {
        "-name": "main_bottom_nav_menu_profile",
        "#text": "Profile"
      },
      {
        "-name": "circle_profile_title_text",
        "#text": "Profile"
      },
      {
        "-name": "user_tag_author",
        "#text": "Author"
      },
      {
        "-name": "user_agreement_dialog",
        "#text": "Statement of Use"
      },
      {
        "-name": "community_user_agreement",
        "#text": "User Agreement"
      },
      {
        "-name": "nova_community_agree_continue",
        "#text": "Agree and continue"
      },
      {
        "-name": "nova_community_disagree_quit",
        "#text": "Disagree and exit"
      },
      {
        "-name": "nova_community_agreement_message",
        "#cdata-section": "To provide services for you, OnePlus Community needs your permission to access the internet. If you upload photos, it will also need permission to access your SD card. By tapping \"Agree and continue\", you agree to the <policy>OnePlus Privacy Notice</policy> and <agreement>User Agreement</agreement>. If you select \"Disagree and exit\", you will be unable to use this app. Please read all the relevant documents and supplementary materials to ensure you fully understand OnePlus' policy."
      },
      {
        "-name": "analytics_collection_dialog",
        "#text": "Join User Experience Program"
      },
      {
        "-name": "analytics_collection_message",
        "#cdata-section": "<experience>User Experience Program</experience> is designed to improve the user experience of the OnePlus Community by continually improving product performance and introducing services that are helpful to you."
      },
      {
        "-name": "dialog_save",
        "#text": "Save"
      },
      {
        "-name": "nova_toast_loading",
        "#text": "Loading…"
      },
      {
        "-name": "nova_community_delete_fail",
        "#text": "Failed to delete"
      },
      {
        "-name": "nova_community_about_user_experience_program",
        "#cdata-section": "Join <experience>User Experience Program</experience>"
      },
      {
        "-name": "experience_program_agree",
        "#text": "I'm in"
      },
      {
        "-name": "experience_program_disagree",
        "#text": "No, thanks"
      },
      {
        "-name": "profile_edit_user_name_text",
        "#text": "Username"
      },
      {
        "-name": "profile_edit_user_sign_text",
        "#text": "Bio"
      },
      {
        "-name": "profile_edit_user_name_tips",
        "#text": "You can change your username only once"
      },
      {
        "-name": "pick_image_option_gallery",
        "#text": "Gallery"
      },
      {
        "-name": "pick_image_option_camera",
        "#text": "Camera"
      },
      {
        "-name": "publisher_article_video_local",
        "#text": "Upload video"
      },
      {
        "-name": "publisher_article_video_youtube",
        "#text": "Add YouTube video"
      },
      {
        "-name": "publisher_article_delete_image_text",
        "#text": "Delete"
      },
      {
        "-name": "circle_article_edit_text",
        "#text": "Last edited: %1$s"
      },
      {
        "-name": "article_detail_comment_insert_image_limit_tips",
        "#text": "You can only upload one picture per comment"
      },
      {
        "-name": "nova_community_search_sort_most_relevant",
        "#text": "Most relevant"
      },
      {
        "-name": "nova_community_search_sort_latest",
        "#text": "Latest"
      },
      {
        "-name": "nova_community_search_sort_most_viewed",
        "#text": "Most viewed"
      },
      {
        "-name": "nova_community_search_sort_most_liked",
        "#text": "Most liked"
      },
      {
        "-name": "nova_community_search_sort_most_commented",
        "#text": "Most commented"
      },
      {
        "-name": "nova_community_search_range_all_time",
        "#text": "All"
      },
      {
        "-name": "nova_community_search_range_past_week",
        "#text": "Past week"
      },
      {
        "-name": "nova_community_search_range_past_month",
        "#text": "Past month"
      },
      {
        "-name": "nova_community_search_range_past_year",
        "#text": "Past year"
      },
      {
        "-name": "nova_community_label_history",
        "#text": "History"
      },
      {
        "-name": "nova_community_label_search_trending",
        "#text": "Trends"
      },
      {
        "-name": "nova_community_button_clear",
        "#text": "Clear"
      },
      {
        "-name": "nova_community_tab_thread",
        "#text": "Threads"
      },
      {
        "-name": "nova_community_tab_circle",
        "#text": "Circles"
      },
      {
        "-name": "nova_community_tab_user",
        "#text": "Users"
      },
      {
        "-name": "nova_community_search_query_hint",
        "#text": "Search for a thread, circle or user"
      },
      {
        "-name": "nova_community_search_query_circle_hint",
        "#text": "Search within \"%1$s\""
      },
      {
        "-name": "nova_community_confirm_clear_history",
        "#text": "Clear your history?"
      },
      {
        "-name": "personal_space_name",
        "#text": "My profile"
      },
      {
        "-name": "nova_community_nickname_used",
        "#text": "This username is already taken"
      },
      {
        "-name": "nova_community_description_moment_image",
        "#text": "\"Moment image thumbnail\""
      },
      {
        "-name": "nova_community_description_button_send",
        "#text": "\"Send button\""
      },
      {
        "-name": "nova_community_description_article_image",
        "#text": "\"Article image\""
      },
      {
        "-name": "nova_community_description_message_image",
        "#text": "\"Message image\""
      },
      {
        "-name": "nova_community_description_media_name",
        "#text": "\"Media file: %1$s\""
      },
      {
        "-name": "nova_community_description_point_center_icon",
        "#text": "\"Icon for point center\""
      },
      {
        "-name": "common_crop_fragment_name",
        "#text": "CropFragment"
      },
      {
        "-name": "publisher_video_out_time_tips",
        "#text": "Video length limit: 5 seconds–5 minutes"
      },
      {
        "-name": "publisher_video_out_format_tips",
        "#text": "You can only upload video in mp4 format"
      },
      {
        "-name": "publisher_select_video_or_image_tips",
        "#text": "You can't upload videos and pictures in the same post"
      },
      {
        "-name": "explore_small_banner_title",
        "#text": "Recommended"
      },
      {
        "-name": "explore_top_creator_title",
        "#text": "Top Creators"
      },
      {
        "-name": "explore_active_ranking_title",
        "#text": `${VITE_BRAND === 'ONEPLUS' ? 'Active users' : 'Inspirational Members'}`
      },
      {
        "-name": "explore_action_title",
        "#text": "Hide for today"
      },
      {
        "-name": "medal_sort_text",
        "#text": "Lv. %1$d"
      },
      {
        "-name": "medal_acquired_time_text",
        "#text": "Acquired on %1$s"
      },
      {
        "-name": "medal_acquired_text",
        "#text": "Acquire"
      },
      {
        "-name": "medal_equip_text",
        "#text": "Equip medal"
      },
      {
        "-name": "medal_equipped_text",
        "#text": "Equipped"
      },
      {
        "-name": "nova_community_poll_tag_text",
        "#text": "Poll"
      },
      {
        "-name": "nova_community_poll_closed",
        "#text": "Poll closed"
      },
      {
        "-name": "nova_community_title_confirm_to_vote",
        "#text": "Vote for this?"
      },
      {
        "-name": "publisher_poll_add_text",
        "#text": "Add an option"
      },
      {
        "-name": "publisher_poll_timer_text",
        "#text": "Close this poll after"
      },
      {
        "-name": "publisher_poll_timer_reset_text",
        "#text": "Change closing time"
      },
      {
        "-name": "publisher_poll_option_text_hints",
        "#text": "Option %1$d"
      },
      {
        "-name": "publisher_poll_option_not_input_tips",
        "#text": "Please add a poll option"
      },
      {
        "-name": "publisher_title_can_not_change_tips",
        "#text": "You're not allowed to change the title"
      },
      {
        "-name": "publisher_content_can_not_change_tips",
        "#text": "You're not allowed to change the content"
      },
      {
        "-name": "publisher_poll_option_can_not_change_tips",
        "#text": "You're not allowed to change the poll option"
      },
      {
        "-name": "publisher_poll_option_not_timer_tips",
        "#text": "Please select a closing time"
      },
      {
        "-name": "publisher_poll_option_not_reset_timer_tips",
        "#text": "Do not change"
      },
      {
        "-name": "check_in_success",
        "#text": "Checked in successfully"
      },
      {
        "-name": "redcoins_obtained_count",
        "#text": "RedCoins +%1$d"
      },
      {
        "-name": "check_in_already",
        "#text": "You've checked in today."
      },
      {
        "-name": "check_in_consecutive_days_label",
        "#text": "streak"
      },
      {
        "-name": "check_in_total_days_label",
        "#text": "in total"
      },
      {
        "-name": "check_in_extra_red_coins",
        "#cdata-section": "Keep checking in every day for another %1$s to get extra <redcoins>%2$s!</redcoins>"
      },
      {
        "-name": "view_picture",
        "#text": "View picture"
      },
      {
        "-name": "circle_tab_all_text",
        "#text": "All"
      },
      {
        "-name": "circle_joined_list_sort_exit_title_tips",
        "#text": "Discard changes?"
      },
      {
        "-name": "circle_joined_list_sort_exit_cancel",
        "#text": "Cancel"
      },
      {
        "-name": "circle_joined_list_sort_exit_ok",
        "#text": "Discard"
      },
      {
        "-name": "activities_message_type_all",
        "#text": "All"
      },
      {
        "-name": "activities_message_type_comments",
        "#text": "Comments & replies"
      },
      {
        "-name": "copy_user_link_toast",
        "#text": "Profile link copied"
      },
      {
        "-name": "circle_recommend_skip_text",
        "#text": "Skip"
      },
      {
        "-name": "circle_recommend_ok_text",
        "#text": "OK"
      },
      {
        "-name": "circle_recommend_title",
        "#text": "Join new circles"
      },
      {
        "-name": "circle_recommend_select_tips",
        "#text": "Please select a circle"
      },
      {
        "-name": "request_post_notification_title",
        "#text": "Allow \"OnePlus Community\" to send notifications?"
      },
      {
        "-name": "request_post_notification_content",
        "#text": "Receive notifications about community activities and news."
      },
      {
        "-name": "allow",
        "#text": "Allow"
      },
      {
        "-name": "deny",
        "#text": "Deny"
      },
      {
        "-name": "circle_flair_none",
        "#text": "None"
      },
      {
        "-name": "circle_flair_add",
        "#text": "Add tag"
      },
      {
        "-name": "allow_open_other_app",
        "#text": "This link will take you outside the OnePlus Community App"
      },
      {
        "-name": "no_app_can_open",
        "#text": "No app found to open the link."
      },
      {
        "-name": "user_id",
        "#text": "User ID"
      },
      {
        "-name": "user_id_copied",
        "#text": "User ID copied"
      },
      {
        "-name": "quit",
        "#text": "quit"
      },
      {
        "-name": "web_access_network",
        "#text": "Internet access is required to view this content"
      },
      {
        "-name": "nova_community_no_permission",
        "#text": "\"No permission\""
      },
      {
        "-name": "nova_community_permission_write_rationale",
        "#text": "Permission required: Write external storage"
      },
      {
        "-name": "nova_community_delete_conversation",
        "#text": "Are you sure to delete all the conversation history with this user?"
      },
      {
        "-name": "nova_community_delete_msg",
        "#text": "Are you sure to delete this message?"
      },
      {
        "-name": "profile_thread_top",
        "#text": "Top"
      },
      {
        "-name": "profile_thread_lock_text",
        "#text": "Only me"
      },
      {
        "-name": "profile_thread_reviewing_text",
        "#text": "Under Review"
      },
      {
        "-name": "profile_thread_review_not_approved_text",
        "#text": "Removed"
      },
      {
        "-name": "attachment_upload_error_hint",
        "#text": "Image/video upload failed"
      },
      {
        "-name": "nova_community_main_quite_circle_message",
        "#text": "Are you sure to leave this circle?"
      },
      {
        "-name": "nova_community_button_text_joined",
        "#text": "Joined"
      },
      {
        "-name": "nova_community_button_text_pending",
        "#text": "Pending"
      },
      {
        "-name": "powered_by_giphy",
        "#text": "Powered by GIPHY"
      },
      {
        "-name": "user_unblock",
        "#text": "Unblock"
      },
      {
        "-name": "block_success",
        "#text": "You've blocked this user."
      },
      {
        "-name": "unblock_success",
        "#text": "You've unblocked this user"
      },
      {
        "-name": "user_blocked",
        "#text": "You're not allowed to view the profile page of this user."
      },
      {
        "-name": "user_block",
        "-translatable": "false",
        "#text": "@string/block_success"
      },
      {
        "-name": "block_dialog_title",
        "#text": "Block \\@%1$s"
      },
      {
        "-name": "block_dialog_content",
        "#text": "They won't be able to comment, reply, message you or view your profile. They won't be notified that you blocked them."
      },
      {
        "-name": "publisher_select_profile_circle_hint",
        "#text": "Posting under \"My profile\" will limit the visibility of your thread."
      },
      {
        "-name": "publisher_select_recommend_circle_hint",
        "#text": "Here're more circles that might fit your content"
      },
      {
        "-name": "publisher_post_thread_for_recommend_circle_fail_hint",
        "#text": "Joining circle \"%1$s\" failed. Posting thread failed."
      },
      {
        "-name": "publisher_post_thread_for_recommend_circle_success_hint",
        "#text": "You've joined the circle \"%1$s\". Thread posted."
      },
      {
        "-name": "nova_community_sticker_recently",
        "#text": "Recently used"
      },
      {
        "-name": "nova_community_sticker_all",
        "-translatable": "false",
        "#text": "@string/circle_tab_all_text"
      },
      {
        "-name": "all_circle_list_joined_hint",
        "#text": "You have joined the circle"
      },
      {
        "-name": "nova_community_sticker_pack_progress",
        "#text": "Downloading… %1$s"
      },
      {
        "-name": "nova_community_picture_watermark",
        "#text": "Picture watermark"
      },
      {
        "-name": "nova_community_trending_topic_title",
        "#text": "Trending Topics"
      },
      {
        "-name": "nova_community_all_topic_button",
        "#text": "All Topics"
      },
      {
        "-name": "nova_community_title_add_topic",
        "#text": "Add a topic"
      },
      {
        "-name": "nova_community_search_topic_hint",
        "#text": "Search a topic"
      },
      {
        "-name": "nova_community_topics_list_title",
        "#text": "Trending Topics"
      },
      {
        "-name": "nova_community_topics_list_subtitle",
        "#text": "Find the trending topics and join in on the conversation."
      },
      {
        "-name": "nova_community_button_join_topics",
        "#text": "Post"
      },
      {
        "-name": "nova_community_button_follow_topics",
        "#text": "Follow"
      },
      {
        "-name": "nova_community_topic_tab_all",
        "#text": "All Topics"
      },
      {
        "-name": "nova_community_topic_tab_following",
        "#text": "My Following"
      },
      {
        "-name": "nova_community_menu_drafts",
        "#text": "My Drafts"
      },
      {
        "-name": "draft_list_default_content_text",
        "#text": "No title temporarily"
      },
      {
        "-name": "draft_list_delete_tips",
        "#text": "Delete this draft?"
      },
      {
        "-name": "draft_list_delete_ok",
        "#text": "Delete"
      },
      {
        "-name": "draft_list_delete_cancel",
        "#text": "Cancel"
      },
      {
        "-name": "nova_community_hidden",
        "#text": "Hidden"
      },
      {
        "-name": "nova_community_permission_declaration_content",
        "#text": "\"OnePlus Community\" needs permission to access the storage, which is used to post pictures, change avatars, and save pictures, etc."
      },
      {
        "-name": "more_than_two_topic_tips",
        "#text": "You can't add more than three topics."
      },
      {
        "-name": "hide_content_tips",
        "#text": "Are you sure to hide this content? The hidden content can't be recovered."
      },
      {
        "-name": "nova_community_publisher_restore_draft_tips",
        "#text": "The draft was closed by accident. Do you want to recover the previous draft?"
      },
      {
        "-name": "nova_community_publisher_restore_draft_recover",
        "#text": "Recover"
      },
      {
        "-name": "nova_community_publisher_restore_draft_cancel",
        "#text": "Cancel"
      },
      {
        "-name": "nova_community_topic_deleted",
        "#text": "This topic has been deleted."
      },
      {
        "-name": "nova_community_menu_go_topic_center",
        "#text": "All Topics"
      },
      {
        "-name": "nova_community_menu_unfollow_topic",
        "#text": "Unfollow"
      },
      {
        "-name": "nova_community_dialog_title_unfollow_topic",
        "#text": "Are you sure to unfollow this topic?"
      },
      {
        "-name": "nova_community_success",
        "#text": "Success"
      }
    ],
    "plurals": [
      {
        "-name": "nova_community_task_points_award_value",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"%1$s RedCoin\""
          },
          {
            "-quantity": "other",
            "#text": "\"%1$s RedCoins\""
          }
        ]
      },
      {
        "-name": "nova_community_medals_awarded_count",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"%1$d Medal Acquired\""
          },
          {
            "-quantity": "other",
            "#text": "%1$d medals acquired"
          }
        ]
      },
      {
        "-name": "nova_community_circle_members_count",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$d Member"
          },
          {
            "-quantity": "other",
            "#text": "%1$d members"
          }
        ]
      },
      {
        "-name": "nova_community_text_exceeded",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"You have exceeded %1$d character\""
          },
          {
            "-quantity": "other",
            "#text": "You have exceeded %1$d characters"
          }
        ]
      },
      {
        "-name": "nova_community_like_count",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$d like"
          },
          {
            "-quantity": "other",
            "#text": "%1$d likes"
          }
        ]
      },
      {
        "-name": "nova_community_view_all_replies",
        "item": [
          {
            "-quantity": "one",
            "#text": "View %1$d reply"
          },
          {
            "-quantity": "other",
            "#text": "View %1$d replies"
          }
        ]
      },
      {
        "-name": "nova_community_publisher_select_image_limit_hints",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"You can only select up to %1$d picture\""
          },
          {
            "-quantity": "other",
            "#text": "You can only select up to %1$d pictures"
          }
        ]
      },
      {
        "-name": "nova_community_publisher_select_video_link_limit_hints",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"You can only select up to %1$d youtube video\""
          },
          {
            "-quantity": "other",
            "#text": "You can only select up to %1$d YouTube videos"
          }
        ]
      },
      {
        "-name": "home_my_circle_articles_count",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$d update"
          },
          {
            "-quantity": "other",
            "#text": "%1$d updates"
          }
        ]
      },
      {
        "-name": "nova_community_total_votes",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$s vote"
          },
          {
            "-quantity": "other",
            "#text": "%1$s votes"
          }
        ]
      },
      {
        "-name": "nova_community_remaining_time_minutes",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$d minute left"
          },
          {
            "-quantity": "other",
            "#text": "%1$d minutes left"
          }
        ]
      },
      {
        "-name": "nova_community_remaining_time_hours",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$d hour left"
          },
          {
            "-quantity": "other",
            "#text": "%1$d hours left"
          }
        ]
      },
      {
        "-name": "nova_community_remaining_time_days",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$d day left"
          },
          {
            "-quantity": "other",
            "#text": "%1$d days left"
          }
        ]
      },
      {
        "-name": "nova_community_count_days",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$d day"
          },
          {
            "-quantity": "other",
            "#text": "%1$d days"
          }
        ]
      },
      {
        "-name": "red_coins",
        "item": [
          {
            "-quantity": "one",
            "#text": "%1$d RedCoin"
          },
          {
            "-quantity": "other",
            "#text": "%1$d RedCoins"
          }
        ]
      },
      {
        "-name": "circle_plaza_thread_count",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"%1$s thread\""
          },
          {
            "-quantity": "other",
            "#text": "\"%1$s threads\""
          }
        ]
      },
      {
        "-name": "circle_plaza_engagement_count",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"%1$s engagement\""
          },
          {
            "-quantity": "other",
            "#text": "%1$s interactions"
          }
        ]
      },
      {
        "-name": "trending_topic_thread_count",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"%1$s thread\""
          },
          {
            "-quantity": "other",
            "#text": "%1$s threads"
          }
        ]
      },
      {
        "-name": "trending_topic_visited_count",
        "item": [
          {
            "-quantity": "one",
            "#text": "\"%1$s view\""
          },
          {
            "-quantity": "other",
            "#text": "%1$s views"
          }
        ]
      }
    ],
    "#text": ">\n    ",
    "string-array": {
      "-name": "topic_search_recommended_tabs",
      "item": [
        "Recommended",
        "My Following"
      ]
    }
  }
}